import React from 'react';
import styled from 'styled-components';
import { SectionParent, H1, H2, H3 } from '../../StyledComponents';
import Application from '../../../assets/ManageBenefits/application2.svg';
import Cost from '../../../assets/ManageBenefits/cost.svg';
import Field from '../../../assets/ManageBenefits/field.svg';
import Delivery from '../../../assets/ManageBenefits/delivery.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { StaticQuery, graphql } from 'gatsby';
import Image from 'gatsby-image';
import { BottomBanner } from '../BottomBanner';
import BlogPosts from './BlogPosts';
import OurPartners from '../OurPartnersContactUs';

const Section = styled(SectionParent)`
  display: grid;
  justify-items: center;
  width: 100%;
  padding-bottom: 3rem;
  background-color: #f6f8fb;
`;

const PartnersSection = styled(SectionParent)`
  display: grid;
  justify-items: center;
  width: 100%;
  border-bottom: 1px #f6f8fb solid;
`;

const ManageHeading = styled.div`
  text-align: center;
  color: #7a55a5;
  margin-top: 5rem;
`;

export const ManageSecondHeading = styled(ManageHeading)`
  color: #2d2b33;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding-top: 2rem;
  padding-bottom: 3rem;
  /* flex-wrap: wrap; */
  width: 100%;
  margin-right: -3rem;
  margin-left: -3rem;
  justify-content: center;
  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
    padding-top: 0rem;
    margin-top: 0rem;
    padding-bottom: 4rem;
  }
`;

const GridItem = styled.div`
  grid-column: span 1;
  padding: 2rem;
  min-width: 250px;
  margin-top: 2rem;
  margin-right: 1rem;
  background: white;
  box-shadow: 0 1px 4px 0 rgba(66, 56, 128, 0.3);
  border-radius: 4px;
  margin-left: 1rem;
  @media (max-width: 768px) {
    padding-top: 4rem;
    flex: 0 0 calc(100%);
    padding-right: 10%;
    padding-left: 10%;
    display: grid;
    justify-items: center;
  }
  @media (max-width: 400px) {
    min-width: unset;
  }
`;

export const HeaderImgTile = styled(LazyLoadImage)`
  border-radius: 5px 5px 0px 0px;
  width: 100%;
  @media (max-width: 520px) {
    width: 100%;
  }
`;

export const PostTitle = styled.h1`
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  margin: 1rem 2rem 0.5rem 2rem;
  font-stretch: normal;
  line-height: normal;
  /* height: 3em; */
  letter-spacing: normal;
  color: #313133;

  @media (max-width: 768px) {
    font-size: 18px;
    margin: 1rem 1rem 0.5rem 1rem;
  }
`;

export const PostTile = styled.a`
  grid-column: span 4;
  @media (max-width: 1024px) {
    grid-column: span 6;
  }
  @media (max-width: 600px) {
    grid-column: span 12;
  }
`;

const GridItemTitle = styled(H2)`
  font-weight: normal;
  text-transform: uppercase;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #80629b;

  min-height: 3rem;
  margin-top: 1.5rem;
  margin-bottom: 0.8rem;
  @media (max-width: 768px) {
    min-height: 0;
  }
  @media (max-width: 520px) {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }
`;

const GridItemDescription = styled(H3)`
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: center;
  color: #707070;
`;

const imageStyle = {
  height: '98px',
  width: '86px',
};

const ImgContainer = styled.div`
  display: grid;
  justify-items: center;
`;

const PartnersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 2rem;
  margin-top: 3rem;
  margin-bottom: 5rem;

  @media (max-width: 520px) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1.5rem;
  }
`;

const PartnersItem = styled(Image)`
  width: 12rem;
`;

export default class extends React.Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query MyQuery {
            zebra: file(
              relativePath: { eq: "v2/homepage/Zebra/group-57@3x.jpg" }
            ) {
              childImageSharp {
                fluid(maxWidth: 200) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }

            android: file(
              relativePath: { eq: "v2/homepage/Android/group-54@3x.jpg" }
            ) {
              childImageSharp {
                fluid(maxWidth: 200) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }

            mediatek: file(relativePath: { eq: "v2/homepage/mediatek.png" }) {
              childImageSharp {
                fluid(maxWidth: 200) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }
            lenovo: file(
              relativePath: { eq: "v2/homepage/Lenovo/group-53@3x.jpg" }
            ) {
              childImageSharp {
                fluid(maxWidth: 200) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }
          }
        `}
        render={(data: any) => (
          <div>
            <BlogPosts />
          </div>
        )}
      />
    );
  }
}
